(() => {
  const initArtworkGuide = (root = document) => {
    const guide = root.querySelector?.('[data-elevenp-artwork-guide]');
    if (!guide || guide.dataset.elevenpArtworkReady === 'true') return;

    const links = Array.from(guide.querySelectorAll('.elevenp-artwork-contents a[href^="#"]'));
    const targets = links
      .map((link) => document.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    if (!links.length || !targets.length) return;
    guide.dataset.elevenpArtworkReady = 'true';

    const setActive = (id) => {
      links.forEach((link) => {
        const active = link.getAttribute('href') === `#${id}`;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };

    setActive(targets[0].id);

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: '-18% 0px -65% 0px', threshold: [0, 0.15, 0.35] },
    );

    targets.forEach((target) => observer.observe(target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initArtworkGuide(), { once: true });
  } else {
    initArtworkGuide();
  }

  document.addEventListener('shopify:section:load', (event) => initArtworkGuide(event.target));
})();
